import { APIS_DASHBOARD, APIS_DRIVE, APIS_MAP, APIS_PREDICT, TIMEOUTTIME } from "@/constants/apis";
import { showConsoleError } from "@/functions/errors";
import { getArrayOrSingle } from "@/functions/project";
import axios from "axios";
import { ref, computed } from "vue";

import store from "@/store";
import { NAME_PROJECT, TOKEN } from "@/constants/labels";
const projectName = computed(() => store.state.projectName);

export async function getAllLatencyLast() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_DASHBOARD.value.getAllLatencyLastMinute, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalOBJ = ref<any>([]);
      const showGraphs = ref(finalData.length > 0);

      if (finalData.length > 0) {
        finalOBJ.value = finalData;
      }
      statusAxios.value = {
        status: 200,
        data: finalOBJ.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getLastRXLVLandSNR() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_DASHBOARD.value.getLastRXLVLandSNR, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalOBJ = ref<any>([]);
      const showGraphs = ref(finalData.length > 0);

      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          if (
            projectName.value === NAME_PROJECT.cananea ||
            projectName.value === NAME_PROJECT.demo ||
            projectName.value === NAME_PROJECT.nacozari
          ) {
            const allrxsnr = JSON.parse(
              item.rxsnr ?? `{"V" : 0, "H" : 0, "PER" : 0}`,
            );

            const SNRV = getArrayOrSingle(allrxsnr["V"], 3);
            const SNRH = getArrayOrSingle(allrxsnr["H"], 3);
            const LVLRX = getArrayOrSingle(allrxsnr["H"], 1);
            const LVLTX = getArrayOrSingle(allrxsnr["V"], 1);

            if (LVLRX) {
              finalOBJ.value.push({
                ip: item.ip,
                snrv: SNRV,
                snrh: SNRH,
                rxlvl: LVLRX,
                txlvl: LVLTX,
              });
            }
          } else {
            const allThrougtput = JSON.parse(
              item.througtput ?? `{"inthroughputbytes": 0}`,
            );
            const finalThrougtput = parseFloat(
              (allThrougtput.inthroughputbytes / (1024 * 1024)).toFixed(2),
            );

            // Convierte a JSON la variable "snr"
            // Si no existe, el valor por default es {"V": 0, "H":0}
            const allSNR = JSON.parse(item.snr ?? `{"V": 0, "H": 0}`);

            // Como trae valores simples o en un array, primero se valida llamando a la funcion "getArrayOrSingle"
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            const SNRV = getArrayOrSingle(allSNR["V"], 0);
            const SNRH = getArrayOrSingle(allSNR["H"], 0);

            // Convierte a JSON la variable "link_radio"
            // Si no existe, el valor por default es {"tx": 0, "rx":0}
            const allRADIO = JSON.parse(item.link_radio ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida llamando a la funcion "getArrayOrSingle"
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            const RADIOrx = getArrayOrSingle(allRADIO["rx"], 0);
            const RADIOtx = getArrayOrSingle(allRADIO["tx"], 0);

            finalOBJ.value.push({
              ip: item.ip,
              snrv: SNRV,
              snrh: SNRH,
              rxlvl: RADIOrx,
              txlvl: RADIOtx,
              througtput: finalThrougtput,
            });
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalOBJ.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getRajantLastGPS() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_DRIVE.value.getRajantGPS, {
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          const finalGPS = `[${item.latitud}, ${item.longitud}, ${item.altitud}]`;
          finalObj.value.push({
            gps: finalGPS,
            ip: item.ip,
            name: item.name,
            tipo: item.tipo,
          });
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}


export async function getAllHexagon() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_MAP.value.getClusteringDataTestTransform, {
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any>({});
      const showGraphs = ref(true);
      if (finalData) {
        finalObj.value = finalData
        statusAxios.value = {
          status: 200,
          data: finalObj.value,
          showGraphs: showGraphs.value,
        };
      }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllHexagonTemperature() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_MAP.value.getClusteringDataTemperatureToFront, {
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any>({});
      const showGraphs = ref(true);
      if (finalData) {
        finalObj.value = finalData
        statusAxios.value = {
          status: 200,
          data: finalObj.value,
          showGraphs: showGraphs.value,
        };
      }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}


export async function getDataTemperaturePredictLastMinute() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getDataTemperaturePredictLastMinute, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalOBJ = ref<any>([]);
      const showGraphs = ref(finalData.length > 0);

      if (finalData.length > 0) {
        finalOBJ.value = finalData;
      }
      statusAxios.value = {
        status: 200,
        data: finalOBJ.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}